// Caminho relativo: src/app/components/alert/alert.component.ts
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit, OnDestroy {
  private subscription: Subscription;
  message: any;

  constructor(private alertService: AlertService) { }

  ngOnInit() {
    this.subscription = this.alertService.getAlert()
      .subscribe(message => {
        switch (message && message.type) {
          case 'success':
            message.cssClass = 'alert-chip alert-chip-success';
            break;
          case 'warning':
            message.cssClass = 'alert-chip alert-chip-warning';
            break;
          case 'error':
            message.cssClass = 'alert-chip alert-chip-danger';
            break;
        }

        this.message = '';
        this.message = message;

        setTimeout(() => {
          if (this.message) this.message = ""
        }, 3000)
      });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


}
